<template>
  <v-dialog v-model="visible" max-width="1200px" scrollable persistent>
    <v-card>
      <v-toolbar dense flat color="primary" dark>
        <v-toolbar-title class="text-subtitle-1 font-weight-bold">
          <v-icon left small>mdi-school</v-icon>
          VER PROGRAMA UNIVERSIDAD
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon small dark @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0" style="max-height: 78vh; overflow-y: auto">
        <v-stepper v-model="pasoActual" flat non-linear class="elevation-0">
          <v-stepper-header class="elevation-0">
            <v-stepper-step :complete="pasoActual > 1" step="1" editable> Datos del Programa </v-stepper-step>
            <v-divider />
            <v-stepper-step :complete="pasoActual > 2" step="2" editable>
              Plan de Pago y Precios de Referencia
            </v-stepper-step>
            <v-divider />
            <v-stepper-step step="3" editable> Módulos </v-stepper-step>
          </v-stepper-header>

          <v-divider class="my-0" />

          <v-stepper-items>
            <!-- ==================== PASO 1: DATOS DEL PROGRAMA ==================== -->
            <v-stepper-content step="1" class="pa-5">
              <!-- Sede -->
              <v-sheet rounded outlined class="pa-4 mb-4">
                <div class="d-flex align-center">
                  <v-icon color="primary" class="mr-3">mdi-map-marker</v-icon>
                  <div>
                    <div class="text-caption grey--text">Sede Universidad</div>
                    <div class="font-weight-medium">{{ item.sedeUniversidad?.nombre || '-' }}</div>
                    <div v-if="item.sedeUniversidad?.institucion" class="text-caption text-uppercase grey--text">
                      {{ item.sedeUniversidad.institucion.nombre }}
                    </div>
                  </div>
                </div>
              </v-sheet>

              <!-- Datos del Programa -->
              <v-sheet class="pa-4 mb-4 seccion" rounded>
                <div class="seccion-titulo mb-3">
                  <v-icon small color="primary" class="mr-2">mdi-text-box-outline</v-icon>
                  <span>Datos del Programa</span>
                </div>

                <v-row dense>
                  <v-col cols="12" sm="6" md="4">
                    <div class="campo-lectura">
                      <div class="campo-label">Código</div>
                      <div class="campo-valor">{{ item.codigo || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="8">
                    <div class="campo-lectura">
                      <div class="campo-label">Nombre del Programa</div>
                      <div class="campo-valor">{{ item.programaNombre || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <div class="campo-lectura">
                      <div class="campo-label">Tipo / Categoría</div>
                      <div class="campo-valor">{{ item.categoriaUniversidad?.nombre || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <div class="campo-lectura">
                      <div class="campo-label">Área</div>
                      <div class="campo-valor">{{ item.areaUniversidad?.nombre || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <div class="campo-lectura">
                      <div class="campo-label">Modalidad</div>
                      <div class="campo-valor">{{ modalidadesLabels[item.modalidad] || item.modalidad || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <div class="campo-lectura">
                      <div class="campo-label">Versión</div>
                      <div class="campo-valor">{{ item.version || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <div class="campo-lectura">
                      <div class="campo-label">Resolución Aprobación</div>
                      <div class="campo-valor">{{ item.resolucionAprobacionUniversidad || '-' }}</div>
                    </div>
                  </v-col>
                </v-row>
              </v-sheet>

              <!-- Gestión y Fechas -->
              <v-sheet class="pa-4 mb-4 seccion" rounded>
                <div class="seccion-titulo mb-3">
                  <v-icon small color="primary" class="mr-2">mdi-calendar-clock</v-icon>
                  <span>Gestión y Fechas</span>
                </div>

                <v-row dense>
                  <v-col cols="12" sm="6" md="3">
                    <div class="campo-lectura">
                      <div class="campo-label">Gestión</div>
                      <div class="campo-valor">{{ item.gestion || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="campo-lectura">
                      <div class="campo-label">Grupo</div>
                      <div class="campo-valor">{{ item.grupo || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="campo-lectura">
                      <div class="campo-label">Fecha Inicio</div>
                      <div class="campo-valor">{{ formatearFechaCadena(item.fechaInicio) || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="campo-lectura">
                      <div class="campo-label">Fecha Fin</div>
                      <div class="campo-valor">{{ formatearFechaCadena(item.fechaFin) || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="campo-lectura">
                      <div class="campo-label">Fecha Inscripción</div>
                      <div class="campo-valor">{{ formatearFechaCadena(item.fechaInscripcion) || '-' }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="campo-lectura">
                      <div class="campo-label">Estado</div>
                      <div class="campo-valor">
                        <v-chip x-small :color="item.estado === 'activo' ? 'success' : 'grey'" dark>
                          {{ (item.estado || '-').toUpperCase() }}
                        </v-chip>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-stepper-content>

            <!-- ==================== PASO 2: PLAN DE PAGO Y PRECIOS ==================== -->
            <v-stepper-content step="2" class="pa-5">
              <!-- Plan de Pago -->
              <v-sheet class="pa-4 mb-4 seccion" rounded>
                <div class="seccion-titulo mb-3">
                  <v-icon small color="primary" class="mr-2">mdi-cash-multiple</v-icon>
                  <span>Plan de Pago</span>
                </div>

                <div v-if="!item.planPagoUniversidad" class="text-center py-3">
                  <v-icon size="48" color="grey" class="mb-2">mdi-file-document-outline</v-icon>
                  <div class="grey--text">No tiene plan de pago asignado</div>
                </div>

                <template v-else>
                  <div class="font-weight-medium mb-2">{{ item.planPagoUniversidad.nombre }}</div>
                  <TablaPlanesPagosConceptosUniversidades
                    v-if="item.planPagoUniversidad.planesPagosConceptosUniversidades"
                    :planesPagosConceptosUniversidades="item.planPagoUniversidad.planesPagosConceptosUniversidades" />
                </template>
              </v-sheet>

              <!-- Precios de Referencia -->
              <v-sheet class="pa-4 mb-4 seccion" rounded>
                <div class="d-flex flex-wrap align-center justify-space-between mb-3">
                  <div class="seccion-titulo mb-3">
                    <v-icon small color="primary" class="mr-2">mdi-currency-usd</v-icon>
                    <span>
                      Precios de Referencia
                      <v-chip x-small class="ml-2" color="primary" outlined>
                        {{ preciosTodosLosTipos.length }}
                        {{ preciosTodosLosTipos.length === 1 ? 'precio' : 'precios' }}
                      </v-chip>
                    </span>
                  </div>

                  <div v-if="puedeConsultarPrecios" class="d-flex flex-wrap gap-1 mb-3">
                    <span class="caption grey--text mx-2">Precios basados en:</span>
                    <v-chip small outlined>{{ item.categoriaUniversidad?.nombre || '-' }}</v-chip>
                    <v-chip small outlined>{{ item.areaUniversidad?.nombre || '-' }}</v-chip>
                    <v-chip small outlined>{{ modalidadesLabels[item.modalidad] || '-' }}</v-chip>
                  </div>

                  <v-btn
                    v-if="puedeConsultarPrecios"
                    small
                    color="primary"
                    outlined
                    @click="obtenerPreciosTodosLosTipos">
                    <v-icon left small>mdi-refresh</v-icon>
                    Buscar Precios
                  </v-btn>
                </div>

                <v-alert v-if="!puedeConsultarPrecios" type="warning" dense text class="mb-0">
                  No se puede consultar precios: faltan datos de categoría, área o modalidad.
                </v-alert>

                <v-alert v-else-if="errorPrecios" type="error" dense text class="mb-0">
                  {{ errorPrecios }}
                </v-alert>

                <template v-else>
                  <v-tabs v-model="tabPrecios" dense height="32" class="mb-2">
                    <v-tab class="text-caption">Pivot</v-tab>
                    <v-tab class="text-caption">Lista</v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tabPrecios">
                    <v-tab-item>
                      <TablaPivotPreciosTodosLosTipos :items="preciosTodosLosTipos" :cargando="cargandoPrecios" />
                    </v-tab-item>
                    <v-tab-item>
                      <TablaPreciosTodosLosTipos :items="preciosTodosLosTipos" :cargando="cargandoPrecios" />
                    </v-tab-item>
                  </v-tabs-items>
                </template>
              </v-sheet>
            </v-stepper-content>

            <!-- ==================== PASO 3: MÓDULOS ==================== -->
            <v-stepper-content step="3" class="pa-5">
              <v-sheet class="pa-4 seccion" rounded>
                <div class="d-flex flex-wrap align-center justify-space-between mb-3">
                  <div class="seccion-titulo">
                    <v-icon small color="primary" class="mr-2">mdi-view-module</v-icon>
                    <span>Módulos del Programa</span>
                    <v-chip x-small class="ml-2" color="primary" outlined>
                      {{ modulos.length }}
                    </v-chip>
                  </div>
                </div>

                <v-alert v-if="modulos.length === 0" type="info" text dense class="mb-0">
                  No tiene módulos registrados.
                </v-alert>

                <v-card v-for="(modulo, index) in modulos" :key="index" outlined class="modulo-card mb-3">
                  <div class="modulo-header">
                    <div class="d-flex align-center">
                      <v-avatar size="26" color="primary" class="mr-2">
                        <span class="white--text caption font-weight-bold">{{ modulo.numero }}</span>
                      </v-avatar>
                      <span class="font-weight-medium">{{ modulo.nombre || '-' }}</span>
                    </div>
                  </div>

                  <div class="modulo-body">
                    <v-row dense>
                      <v-col cols="12" sm="6" lg="3">
                        <div class="campo-lectura">
                          <div class="campo-label">Hrs. Presencial</div>
                          <div class="campo-valor">{{ modulo.cargaHorariaPresencial ?? '-' }}</div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" lg="3">
                        <div class="campo-lectura">
                          <div class="campo-label">Hrs. No Presencial</div>
                          <div class="campo-valor">{{ modulo.cargaHorariaNoPresencial ?? '-' }}</div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" lg="3">
                        <div class="campo-lectura">
                          <div class="campo-label">Fecha Inicio</div>
                          <div class="campo-valor">{{ formatearFechaCadena(modulo.fechaInicio) || '-' }}</div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" lg="3">
                        <div class="campo-lectura">
                          <div class="campo-label">Fecha Fin</div>
                          <div class="campo-valor">{{ formatearFechaCadena(modulo.fechaFin) || '-' }}</div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-sheet>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>

      <v-divider />

      <v-card-actions class="px-5 py-3">
        <v-btn v-if="pasoActual > 1" text @click="pasoActual--">
          <v-icon left small>mdi-arrow-left</v-icon>
          Anterior
        </v-btn>
        <v-btn v-if="pasoActual < 3" color="secondary" @click="pasoActual++">
          Siguiente
          <v-icon right small>mdi-arrow-right</v-icon>
        </v-btn>

        <v-spacer />

        <v-btn text @click="cerrar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListaPrecioService from '../../services/lista-precio.service';
import TablaPlanesPagosConceptosUniversidades from '../TablaPlanesPagosConceptosUniversidades.vue';
import TablaPreciosTodosLosTipos from '../ListaPrecio/TablaPreciosTodosLosTipos.vue';
import TablaPivotPreciosTodosLosTipos from '../ListaPrecio/TablaPivotPreciosTodosLosTipos.vue';
import { ModalidadesProgramasUniversidadesLabels } from '../../utils/constantes';
import { formatearFechaCadena } from '../../utils/funciones';

export default {
  name: 'ModalMostrarProgramaUniversidadV2',
  components: {
    TablaPlanesPagosConceptosUniversidades,
    TablaPreciosTodosLosTipos,
    TablaPivotPreciosTodosLosTipos,
  },
  mounted() {
    this.obtenerPreciosTodosLosTipos();
  },
  data() {
    return {
      visible: false,
      pasoActual: 1,
      item: {},
      preciosTodosLosTipos: [],
      cargandoPrecios: false,
      errorPrecios: null,
      tabPrecios: 0,
      modalidadesLabels: ModalidadesProgramasUniversidadesLabels,
    };
  },
  computed: {
    modulos() {
      return (this.item.modulosProgramasUniversidades || []).slice().sort((a, b) => a.numero - b.numero);
    },
    puedeConsultarPrecios() {
      return !!(
        this.item.sedeUniversidad?.universidadId &&
        this.item.categoriaUniversidad?.nombre &&
        this.item.areaUniversidad?.nombre &&
        this.item.modalidad
      );
    },
  },
  watch: {
    pasoActual(newVal) {
      if (newVal == 2) {
        this.obtenerPreciosTodosLosTipos();
      }
    },
  },
  methods: {
    formatearFechaCadena,
    abrir(data) {
      this.item = data || {};
      this.pasoActual = 1;
      this.preciosTodosLosTipos = [];
      this.errorPrecios = null;
      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
    async obtenerPreciosTodosLosTipos() {
      if (!this.puedeConsultarPrecios) return;

      this.cargandoPrecios = true;
      this.errorPrecios = null;
      this.preciosTodosLosTipos = [];

      try {
        const { data } = await ListaPrecioService.consultarPreciosTodosLosTipos({
          params: {
            universidadId: this.item.sedeUniversidad.universidadId,
            categoria: this.item.categoriaUniversidad.nombre,
            area: this.item.areaUniversidad.nombre,
            modalidad: this.item.modalidad,
          },
        });
        this.preciosTodosLosTipos = data.datos || [];
      } catch (error) {
        this.preciosTodosLosTipos = [];
        this.errorPrecios = 'Error al consultar precios. Intente nuevamente.';
      } finally {
        this.cargandoPrecios = false;
      }
    },
  },
};
</script>

<style scoped>
.seccion {
  border-left: 3px solid #1976d2;
  background-color: #fafafa;
}

.seccion-titulo {
  display: flex;
  align-items: center;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #1565c0;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.campo-lectura {
  padding: 6px 0;
}

.campo-label {
  font-size: 0.75rem;
  color: #9e9e9e;
  margin-bottom: 2px;
}

.campo-valor {
  font-size: 0.875rem;
  color: #212121;
}

.modulo-card {
  border-color: #e0e0e0 !important;
}

.modulo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background-color: #eceff1;
  border-bottom: 1px solid #e0e0e0;
}

.modulo-body {
  padding: 12px;
}

::v-deep .v-stepper__header {
  box-shadow: none;
}
</style>
